module.exports = "/static/Images/en/Tree.png";